import $ from 'jquery';
import Handlebars from 'handlebars';
import storageUtil from 'utils/storage-util';

window.bat = $.extend(window.bat || {}, {
  util: {
    hcompile: function (template, data) {
      var tmpl;
      if (template && data) {
        tmpl = template.replace('<![CDATA[', '')
          .replace(']]>', '')
          .replace('//<![CDATA[', '')
          .replace('//]]>', '');
        return Handlebars.compile(tmpl)(data);
      }
      return '';
    },

    /*
      * escape special chars from jquery selectors
      * https://learn.jquery.com/using-jquery-core/faq/how-do-i-select-an-element-by-an-id-that-has-characters-used-in-css-notation/
      */
    jqStrip: function (myid) {
      return myid.replace(/(:|\.|\[|\])/g, '\\$1');
    }
  }
});

// Keeping the Handlebars-namespaced shim in place for backward compatibility
// Please use bat.hcompile() if possible
// Extend handlebars to allow cdata in script tags and return function with data passed at compile time
window.bat.hcompile = window.bat.util.hcompile;
// window.Handlebars.hcompile = window.bat.hcompile;

// random global taints
window.bat.OFFER_DETAIL_MODAL = {}; // from ajax-offers.js

window.bat.updateSETLinks = function () {
  $.map($('a'), function (link) {
    if (String(link.href).indexOf('tab=helpful-resources&tool=black-book') === -1) {
      if (String(link.href).indexOf('southeast.buyatoyota.com') != -1) {
        if (String(link.href).indexOf('originating_zip_code') == -1) {
          if (String(link.href).indexOf('?') == -1) {
            link.href = link.href + '?originating_zip_code=' + storageUtil.getZip();
          } else {
            link.href = link.href + '&originating_zip_code=' + storageUtil.getZip();
          }
        } else {
          var pattern = /originating_zip_code.\d+/;
          link.href = link.href.replace(pattern, 'originating_zip_code=' + storageUtil.getZip());
        }
      }
    }
  });
};

// make sure require is referencing the global window.bat object if used elsewhere
export default window.bat;
